import React from 'react';
import { Users, School, Award, Briefcase } from 'lucide-react';

const StatsSection: React.FC = () => {
  const stats = [
    {
      icon: <Users size={32} className="text-secondary-500" />,
      value: '1000+',
      label: 'Students Counseled'
    },
    {
      icon: <School size={32} className="text-secondary-500" />,
      value: '50+',
      label: 'College Partnerships'
    },
    {
      icon: <Award size={32} className="text-secondary-500" />,
      value: '95%',
      label: 'Success Rate'
    },
    {
      icon: <Briefcase size={32} className="text-secondary-500" />,
      value: '10+',
      label: 'Years Experience'
    }
  ];

  return (
    <section className="py-16 bg-primary-700 text-white">
      <div className="container-custom">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="inline-flex items-center justify-center p-4 bg-primary-600 rounded-full mb-4">
                {stat.icon}
              </div>
              <div className="text-4xl font-bold mb-2">
                {stat.value}
              </div>
              <div className="text-lg text-gray-200">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;